// extracted by mini-css-extract-plugin
module.exports = {"variant-page-header-wrapper":"VariantPageHeader_variant-page-header-wrapper__7Njuj"};